import script from "./AddingControl.vue?vue&type=script&setup=true&lang=js"
export * from "./AddingControl.vue?vue&type=script&setup=true&lang=js"

import "./AddingControl.vue?vue&type=style&index=0&id=410c696c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-410c696c"]])

export default __exports__